module.exports = __webpack_public_path__ + "static/flags/LI-f9a8559ea0ecaa7b0dc5dd2c2147d7bd.gif";